module.exports = __webpack_public_path__ + "img/chr_ts_90_16.341c3964.png";